import { render, staticRenderFns } from "./ModelCustomerCustomRequestCounterOffer.vue?vue&type=template&id=06be7473"
import script from "./ModelCustomerCustomRequestCounterOffer.vue?vue&type=script&lang=js"
export * from "./ModelCustomerCustomRequestCounterOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports